import { FETCH_SOCIAL_MEDIA_SUBMISSION, FETCH_SOCIAL_MEDIA_WINNERS } from '../actions';
const initialState = {
  socialMediaSubmissions: []
};

function socialMediaSubmissionsReducer(state = initialState, action) {
  let socialMediaSubmissions,socialMediaWinners;
  switch (action.type) {
    case `${FETCH_SOCIAL_MEDIA_SUBMISSION}_PENDING`:
    case `${FETCH_SOCIAL_MEDIA_WINNERS}_PENDING`:
      return { ...state, 
        loading: true,
      };

    case `${FETCH_SOCIAL_MEDIA_SUBMISSION}_FULFILLED`:
        socialMediaSubmissions = action.payload.data;
      return { ...state, loading: false, socialMediaSubmissions };

    case `${FETCH_SOCIAL_MEDIA_WINNERS}_FULFILLED`:
        socialMediaWinners = action.payload.data;
      return { ...state, loading: false, socialMediaWinners };

    case `${FETCH_SOCIAL_MEDIA_SUBMISSION}_REJECTED`:
      return {...state, loading: false, socialMediaSubmissionsError: action.payload.response.data, state: initialState };

    case `${FETCH_SOCIAL_MEDIA_WINNERS}_REJECTED`:
      return {...state, loading: false, socialMediaWinnersError: action.payload.response.data, state: initialState };

    default:
      return state;
  }
}

export default socialMediaSubmissionsReducer;
